// extracted by mini-css-extract-plugin
module.exports = {"missionSectionWrapper":"mission_missionSectionWrapper__YCMbT","missionRightSection":"mission_missionRightSection__SJNwf"};